import { useGetBuyerSpendingLimit } from '@api/lendingAPI/lapiHooks';

import { getSpendingLimitStatus } from '../Dashboard.helpers';
import { DeclinedLimits } from './components/DeclinedLimits';
import { ExpiredLimits } from './components/ExpiredLimits';
import { ValidLimits } from './components/ValidLimits';
import styles from './SpendingLimitCard.module.css';
import { Application } from '../Dashboard.types';

const SpendingLimitCard = ({
    setIsSpendingLimitDrawerOpen,
    refreshSpendingLimit,
    loadingRefreshSpendingLimit,
    application
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refreshSpendingLimit: () => Promise<void>;
    loadingRefreshSpendingLimit: boolean;
    application: Application | null;
}) => {
    const { buyerSpendingLimit, loadingBuyerSpendingLimit } =
        useGetBuyerSpendingLimit();
    const activeSpendingLimit = buyerSpendingLimit?.active_spending_limit;

    if (loadingBuyerSpendingLimit || !activeSpendingLimit) return null;

    // Legacy compatibility to remove the old endpoint first
    const status = getSpendingLimitStatus({
        spendingLimits: { isValid: activeSpendingLimit.is_valid },
        application
    });

    return (
        <div className={styles.outerContainer}>
            {status === 'valid' && (
                <ValidLimits
                    setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
                />
            )}
            {status === 'expired' && (
                <ExpiredLimits
                    setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
                    refreshSpendingLimit={refreshSpendingLimit}
                    loading={loadingRefreshSpendingLimit}
                />
            )}
            {status === 'declined' && (
                <DeclinedLimits
                    setIsSpendingLimitDrawerOpen={setIsSpendingLimitDrawerOpen}
                    refreshSpendingLimit={refreshSpendingLimit}
                    loading={loadingRefreshSpendingLimit}
                    application={application!}
                />
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default SpendingLimitCard;
